import script from "./multiple-checks.vue?vue&type=script&lang=js"
export * from "./multiple-checks.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/input-only/multiple-checks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bceaae3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bceaae3', __exports__)) {
    console.log('reload')
    api.reload('1bceaae3', __exports__)
  }
  
}


export default __exports__